export const Blogs = [
    {
        id:1,
        name:"Build Website with ReactJS, Styled-components and GSAP for Scrolling Animations",
        tags:["react","gsap","styled-components"],
        date:"13 May, 2021",
    },
    {
        id:2,
        name:"How to create React Hamburger Menu using Styled-Components",
        tags:["react","styled-components"],
        date:"5 July, 2021",
    },
    {
        id:3,
        name:"React Loading Screen: Try these 3 cool loading screens for your app",
        tags:["react","react-lottie","styled-components"],
        date:"6 July, 2021",
    },
    {
        id:4,
        name:"How to build a Fabulous Todo App using React, Redux and Framer-Motion",
        tags:["react","redux","framer-motion"],
        date:"26 May, 2021",
    },
    {
        id:5,
        name:"What is Higher Order Component (HOC) in React JS?",
        tags:["react","reactJS","web-development"],
        date:"3 Feb, 2021",
    },
    {
        id:6,
        name:"How to implement Pagination Component in React from scratch",
        tags:["react","css"],
        date:"5 Jan, 2021",
    },
   
    {
        id:7,
        name:"What is Redux ? Simply Explained!",
        tags:["react","redux","javascript"],
        date:"16 May, 2021",
    },
    {
        id:8,
        name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
        tags:["react","framer-motion","styled-components"],
        date:"26 May, 2021",
    },
  
] 